export function fetchQueueItem(url, data, done, itemID) {
    if (window.EventBusLimitedRequestQueue.cache[url.href]) {
        const imageObjectURL = window.EventBusLimitedRequestQueue.cache[url.href];
        window.EventBusLimitedRequestQueue.trigger(`fetch:${itemID}`, imageObjectURL);
    } else {
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    window.EventBusLimitedRequestQueue.trigger(`fetch:failure:${itemID}`);
                    const error = new Error('Response status !== 20x');
                    error.name = 'CancelPromiseChainError';
                    throw error;
                }
                return response.blob();
            })
            .then((imageBlob) => {
                const imageObjectURL = URL.createObjectURL(imageBlob);
                window.EventBusLimitedRequestQueue.cache[url.href] = imageObjectURL;
                return imageObjectURL;
            })
            .then((imageObjectURL) => window.EventBusLimitedRequestQueue.trigger(`fetch:success:${itemID}`, imageObjectURL))
            .catch(error => {
                if (error.name !== 'CancelPromiseChainError') {
                    // re-raise
                    throw error;
                }
            })
            .finally(() => done())
    }
}



// WEBPACK FOOTER //
// /src/queuehandler.js